import React from 'react';
import DebugPanel from 'Components/UI/DebugPanel';
import { DebugProvider } from 'Context/DebugContext';
import { SnackbarContextProvider } from 'Context/SnackbarContext';
import { OnboardingHeaderProvider } from 'Views/Onboarding/Contexts/OnboardingHeaderContext';
import OnboardingHasUserContainer from './OnboardingHasUserContainer';
import { OnboardingProvider } from '../Contexts/OnboardingContext';
import { OnboardingFooterProvider } from '../Contexts/OnboardingFooterContext';

import OnboardingDebugPanel from './OnboardingDebugPanel';

const OnboardingHasUser = () => {
  return (
    <OnboardingProvider>
      <OnboardingHeaderProvider>
        <OnboardingFooterProvider>
          <DebugProvider initialState={null}>
            <DebugPanel>
              <OnboardingDebugPanel />
            </DebugPanel>
            <SnackbarContextProvider>
              <OnboardingHasUserContainer />
            </SnackbarContextProvider>
          </DebugProvider>
        </OnboardingFooterProvider>
      </OnboardingHeaderProvider>
    </OnboardingProvider>
  );
};

export default OnboardingHasUser;
